export const fillPhoneInputValue = ({ drawerData, index, values, readOnly }) => {
    if (drawerData.length > 0 && drawerData[index]) {
      drawerData[index].state = {
        ...drawerData[index].state,
        phoneValue: values.phoneValue,
        mainPhoneInput: values.phoneInput,
        alertValue: values.alertValue,
        readOnly,
      };
    }
  };
  